import { Grid, GridExportRequestedEvent, excelWorkbook } from '@inavista/components/grid';
import { getCurrentDate } from '../../../utils/date-functions';

/**
 * "<fileName>(<date>).xlsx" of a DRO grid: the visible columns as the grid shows them (labels, formats), and the rows the
 * grid gathered for the export (every filtered row of a paged grid), else the rows on screen.
 */
export async function exportDroGrid(grid: Grid, event: GridExportRequestedEvent | null, fileName: string): Promise<void> {
  const sheet = event?.excel ?? grid.excelSheet(event?.rows ?? grid.visibleRows());
  const blob = await excelWorkbook(sheet.rows, sheet.columns, { sheetName: fileName.slice(0, 31) });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `${fileName}(${getCurrentDate()}).xlsx`;
  link.click();
  setTimeout(() => window.URL.revokeObjectURL(link.href), 1000);
}
